const TEAM_DETAILS_PREFIX = "teamdetails_";

export interface TeamDetails {
  teamId: string;
  teamName?: string;
}

export function getTeamDetailsKey(uuid: string): string {
  return `${TEAM_DETAILS_PREFIX}${uuid}`;
}

export function getTeamDetails(
  uuid?: string | null
): TeamDetails | null {
  if (!uuid) {
    return null;
  }
  try {
    const raw = localStorage.getItem(getTeamDetailsKey(uuid));
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !parsed.teamId) {
      return null;
    }
    return parsed as TeamDetails;
  } catch {
    return null;
  }
}

export function setTeamDetails(
  uuid?: string | null,
  details?: TeamDetails | null
): void {
  if (!uuid || !details?.teamId) {
    return;
  }
  try {
    localStorage.setItem(getTeamDetailsKey(uuid), JSON.stringify(details));
  } catch (error) {
    try {
      clearAllTeamDetails();
      localStorage.setItem(getTeamDetailsKey(uuid), JSON.stringify(details));
    } catch {
      /* ignore if retry fails (e.g. private mode) */
    }
  }
}

export function clearAllTeamDetails(): void {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(TEAM_DETAILS_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    /* ignore storage failures */
  }
}
